var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[(
            _vm.itemAvailability &&
            ((_vm.itemAvailability.isFresh && !_vm.text) || _vm.text) &&
            !_vm.isShopPage
        )?_c('v-alert',{attrs:{"dense":"","text":_vm.text,"color":_vm.getAlertColor(_vm.itemAvailability.alertType),"border":"left"}},[_c('div',{staticClass:"d-flex align-center",style:(("color: " + (_vm.text || _vm.itemAvailability.alertType === 'error'
                    ? ''
                    : 'white')))},[_c('div',[(_vm.itemAvailability.alertType === 'error')?_c('fa',{staticClass:"fa-lg mr-2",attrs:{"icon":['fal', 'info-circle']}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"d-inline"},[_c('TranslatableStringComponent',{attrs:{"tstring":{
                        string: ("" + (_vm.itemAvailability.availabilityMessage)),
                        variables: [
                            {
                                var: ("" + (_vm.convertToReadabledate(
                                    _vm.itemAvailability.leadDate
                                ))),
                            } ],
                    }}}),_vm._v(" "),_c('a',{attrs:{"href":"tel:+17247757926"}},[(
                            [
                                'contactForAvailability',
                                'mcbAvailabilityMessage' ].includes(_vm.itemAvailability.availabilityMessage)
                        )?_c('TranslatableStringComponent',{attrs:{"tstring":{ string: 'c3Phone' }}}):_vm._e()],1)],1),_vm._v(" "),(_vm.text)?_c('v-btn',{attrs:{"icon":"","small":"","loading":_vm.availabilityLoading}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.itemAvailability && _vm.itemAvailability.isFresh && _vm.isShopPage)?_c('v-chip',{class:{
            'text-wrap': true,
            'on-error': [
                'contactForAvailability',
                'mcbAvailabilityMessage' ].includes(_vm.itemAvailability.availabilityMessage),
            'justify-center': true,
        },staticStyle:{"width":"100%"},attrs:{"color":_vm.getAlertColor(_vm.itemAvailability.alertType),"small":""}},[_c('div',{staticClass:"d-inline"},[_c('TranslatableStringComponent',{attrs:{"tstring":{
                    string: ("" + (_vm.itemAvailability.availabilityMessage)),
                    variables: [
                        {
                            var: ("" + (_vm.convertToReadabledate(
                                _vm.itemAvailability.leadDate
                            ))),
                        } ],
                }}}),_vm._v(" "),_c('a',{attrs:{"href":"tel:+17247757926"}},[(
                        [
                            'contactForAvailability',
                            'mcbAvailabilityMessage' ].includes(_vm.itemAvailability.availabilityMessage)
                    )?_c('TranslatableStringComponent',{attrs:{"tstring":{ string: 'c3Phone' }}}):_vm._e()],1)],1)]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }